import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { ALERT_TYPE } from 'src/app/constants';
import { Account } from 'src/model/account.model';
import { TransactionSubType } from 'src/model/transactionSubType.model';

@Component({
    selector: 'app-add-income',
    templateUrl: './add-income.component.html',
    styleUrls: ['./add-income.component.scss'],
    standalone: false
})
export class AddIncomeComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  @Input() companyBankAccountList: Account[] = [];
  @Input() cashAccountList: Account[] = [];

  selectedAccountId: number;
  selectedSubTypeId: number;

  @Input() paidByDuitLebih: boolean;

  @Output() passEntry = new EventEmitter<any>();
  //2-WAY BINDING INFO
  incomeDate: Date;
  remark: string;
  amount = 0;
  subtypeList: TransactionSubType[] = [];

  disabledSubmit = false;

  constructor() {
    this.incomeDate = new Date();
  }

  setSelectedSubType(subTypeID: number) {
    if (subTypeID === this.selectedSubTypeId)
      return true
    else
      return false;
  }

  ngOnInit(): void {
    if (this.paidByDuitLebih)
      this.getTransactionSubTypes();
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }

  isFieldNull() {
    const paymentNull = (this.amount == undefined || this.amount == 0);
    const remarkNull = (this.remark == undefined || this.remark == "");
    const selectedAccountIdNull = (this.selectedAccountId == undefined);
    const paymentValid = isNaN(this.amount);

    return paymentNull || remarkNull || selectedAccountIdNull || paymentValid
  }

  getTransactionSubTypes() {
    const xhttp = this.restapi.getRequest(this.constructApi.getAllTransactionSubTypes());
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const type = new TransactionSubType(json.id, json.name, json.type, json.assignable, json.enabled);

          this.subtypeList.push(type);
        });
      }
    };
  }

  addIncome() {
    this.disabledSubmit = true;
    const isoTaskDate = (new Date(Number(this.incomeDate))).toISOString();

    const data = {
      "amount": this.amount,
      "accountId": Number(this.selectedAccountId),
      "date": isoTaskDate,
      "remark": this.remark
    };

    const xhr = this.restapi.postRequest(this.constructApi.getAddIncome(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          const account = new Account(this.selectedAccountId, null, null, null, null, null, null, this.amount)
          this.passEntry.emit(account)
          this.reset();
          this.sharedService.openAlert("Successfully added income!", ALERT_TYPE.SUCCESS);
          window.location.reload();
        } else this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  addIncomeOfExtras() {
    this.disabledSubmit = true;

    const isoTaskDate = (new Date(Number(this.incomeDate))).toISOString();
    let data;

    if (this.selectedSubTypeId == undefined) {
      data = {
        "amount": this.amount,
        "accountId": Number(this.selectedAccountId),
        "date": isoTaskDate,
        "remark": this.remark
      };
    } else {
      data = {
        "amount": this.amount,
        "accountId": Number(this.selectedAccountId),
        "date": isoTaskDate,
        "remark": this.remark,
        "subtype": Number(this.selectedSubTypeId)
      };
    }

    const xhr = this.restapi.postRequest(this.constructApi.getAddIncomeOfExtras(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          const account = new Account(this.selectedAccountId, null, null, null, null, null, null, this.amount)
          this.passEntry.emit(account)
          this.reset();
          this.sharedService.openAlert("Successfully added income!", ALERT_TYPE.SUCCESS);
        } else this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  submit() {
    if (this.isFieldNull()) {
      this.sharedService.openAlert('Please fill in all the fields', ALERT_TYPE.DANGER)
    }
    else {
      if (this.paidByDuitLebih)
        this.addIncomeOfExtras();
      else
        this.addIncome();
    }
  }

  reset() {
    this.activeModal.close();
  }
}
